var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoDataEcommerce = function SvgNoDataEcommerce(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9.0-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9.8.0-Minc-Admin-/-Ecommerce-management----empty",
    transform: "translate(-809, -415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/04.Confirmation/Empty-state",
    transform: "translate(697, 415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(112, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F1F1",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(20, 20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6979167,5.41666659 C18.8417408,5.41666659 18.9583333,5.53325911 18.9583333,5.67708326 L18.9583333,14.7916666 C18.9583333,16.5175565 20.3574435,17.9166666 22.0833333,17.9166666 L31.1979167,17.9166666 C31.3417409,17.9166666 31.4583334,18.0332592 31.4583334,18.1770833 L31.4583334,30.4166666 C31.4583334,32.7178532 29.5928532,34.5833334 27.2916667,34.5833334 L12.7083333,34.5833334 C10.4071468,34.5833334 8.54166661,32.7178532 8.54166661,30.4166666 L8.54166661,9.58333328 C8.54166661,7.28214681 10.4071468,5.41666659 12.7083333,5.41666659 Z M21.1221196,6.22071382 C21.1706308,6.20065495 21.2264427,6.21168863 21.2636719,6.24869785 L30.6263021,15.6113281 C30.6633114,15.6485573 30.674345,15.7043692 30.6542862,15.7528803 C30.6342273,15.8013915 30.5869995,15.8331129 30.5345053,15.8333333 L22.0833333,15.8333333 C21.5080367,15.8333333 21.0416667,15.3669633 21.0416667,14.7916666 L21.0416667,6.34049472 C21.0418871,6.28800049 21.0736085,6.2407727 21.1221196,6.22071382 Z",
    id: "Combined-Shape",
    fill: "#999999",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoDataEcommerce, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data-ecommerce.8921dc23.svg";
export { ForwardRef as ReactComponent };